import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ResponsiveContainer from './ResponsiveContainer';

function EmailInputPage({ personalDetails, setPersonalDetails, t }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [invoiceEmail, setEmail] = useState(personalDetails.invoiceEmail || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!invoiceEmail || !invoiceEmail.trim()) {
      alert(t('pleaseEnterEmail'));
      return;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(invoiceEmail)) {
      alert(t('invalidEmail'));
      return;
    }
    
    setIsSubmitting(true);
    
    // Update the personal details with the email
    setPersonalDetails({ ...personalDetails, invoiceEmail: invoiceEmail.trim() });
    
    // Navigate to the language selection page
    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/personal-details');
    }, 500);
  };

  return (
    <ResponsiveContainer>
      <div className="min-h-[calc(100vh-100px)] bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-semibold text-center mb-6">{t('enterAdminEmailAddress')}</h2>
          
          <p className="text-gray-600 mb-6 text-center">
            {t('pleaseEnterEmail')}
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <input
                type="email"
                value={invoiceEmail}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="email@example.com"
                autoFocus
              />
            </div>
            
            <div className="flex justify-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#d0a949] hover:bg-[#a6873a] text-white py-3 px-6 rounded-lg shadow transition duration-200 flex items-center justify-center disabled:opacity-50"
              >
                {isSubmitting ? (
                  <span className="inline-block animate-spin mr-2">⏳</span>
                ) : null}
                {t('submit')}
              </button>
            </div>
          </form>
          
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/language-selection')}
              className="text-gray-500 hover:text-gray-700 text-sm"
            >
              {t('cancelRegistration')}
            </button>
          </div>
        </div>
      </div>
    </ResponsiveContainer>
  );
}

export default EmailInputPage;